import { post, get, patch, del} from '../../http'

const path = '/api/projects'

export default {
    index(params){
        return get(`${path}`, params)
    },
    get(id, params={}){
        return get(`${path}/${id}`, params)
    },
    post(payload){
        return post(`${path}`, payload)
    },
    update(id, payload){
        return patch(`${path}/${id}`, payload)
    },
    delete(id){
        return del(`${path}/${id}`)
    },
    submit(id, payload){
        return post(`${path}/${id}/submit`, payload)
    }
}
